import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Divider } from '@mui/material';
import Typography from '@mui/material/Typography';
import bar from '../../assets/svg/bar.svg';
import Title from '../forms/Title';
import { Subtitle } from '../forms/Title';
import HeadSectionStyle from '../../styles/HeadSectionStyle';
import HeadSectionLayout from '../../styles/HeadSectionLayout';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import StartSection from './StartSection';
import gt_map_location from '../../assets/img/gt_map_location.png';

const HeadSection = () => {
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      <Grid
        container
        rowSpacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}
        columnSpacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}
        direction="row"
      >
        <Grid container data-testid="desktop-head-test">
          <Grid item xs={12} lg={7}>
            <HeadSectionLayout>
              <Grid
                container
                rowSpacing={{ xs: 1, sm: 2, md: 3, lg: 4 }}
                sx={HeadSectionStyle.content}
              >
                <Grid item xs={12} sm={9} md={11} lg={11}>
                  <Box sx={HeadSectionStyle.title}>
                    {isSmallDevice ? (
                      <div>
                        <Subtitle title="Direct Mail Powered by" />
                        <Subtitle title="Real-World Behavior" />
                      </div>
                    ) : (
                      <div>
                        <Title title="Direct Mail Powered by" />
                        <Title title="Real-World Behavior" />
                      </div>
                    )}
                    <img
                      src={bar}
                      id="bar"
                      alt="bar"
                      width="35%"
                      data-testid="bar-test"
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} lg={12}>
                  <Box sx={HeadSectionStyle.detail}>
                    <Typography gutterBottom>
                      Audience-Based Direct Mail is a safe, easy way for
                      advertisers to <strong>deliver premium postcards</strong>{' '}
                      to consumers based on their real-world activity.
                    </Typography>
                    <br />
                    <Typography gutterBottom>
                      GroundTruth views the real-world behavior of consumers to
                      determine their interests or habits, then maps that data
                      to their <strong>home addresses</strong>. This one-stop
                      solution allows you to choose who you want to reach, where
                      and when you want to reach them quickly and easily – for
                      one <strong>all-inclusive</strong> price!
                    </Typography>
                    <Divider />
                  </Box>
                </Grid>
              </Grid>
              <StartSection />
            </HeadSectionLayout>
          </Grid>
          <Grid item xs={0} lg={5} sx={HeadSectionStyle.image}>
            <img
              src={gt_map_location}
              id="gt_map_location"
              alt="GT map location"
              width="100%"
              data-testid="gt-map-location-test"
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default HeadSection;
